<template>
  <div class="moment-list-container">
    <div v-for="item in data" class="moment-item-container">
      <div class="title-container">
        <div class="user-info-container">
          <UserAvatar :userInfo="item.user" size="35"></UserAvatar>
          <div class="base-info-container">
            <div class="nickname" @click="onToUserProfile(item.user)">{{getNickName(item)}}</div>
            <div class="post-time">{{createdAt(item)}}</div>
          </div>
        </div>
      </div>
      <div class="moment-info-box" @click="onShowMoment(item)">
        <div class="images-container">
          <div class="cover-container" v-if="coverUrl(item)">
            <img class="cover-img" v-lazy="coverUrl(item)">
          </div>
          <div class="img-count-container" v-if="imgCountDesc(item)">
            <div class="img-count">{{imgCountDesc(item)}}</div>
          </div>
        </div>
        <div class="title-info" v-if="item.title || item.description"><span class="title-info-span" v-if="item.title">{{item.title}}</span><span class="description-info" v-if="item.description">{{momentDescriptions(item)}}</span> </div>
      </div>
      <div class="item-action-box">
        <div class="action-item-container" @click.stop="onClickDigg(item)">
          <div v-if="item.is_digg" class="digg-icon-font-fill">
            <icon-svg icon-class='like-fill' style="color: red"></icon-svg>
          </div>
          <div v-else class="digg-icon-font">
            <icon-svg icon-class='like'></icon-svg>
          </div>
          <div class="icon-text">{{diggText(item)}}</div>
        </div>
        <div class="action-item-container" @click="onShowMoment(item)">
          <icon-svg icon-class="comment"></icon-svg>
          <div class="icon-text">{{commentText(item)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Icon} from "vant"
  import {createdAtDesc} from "../../util/common";
  import LikeComponent from "../common/LikeComponent";
  import UserAvatar from "../common/UserAvatar";

  export default {
    name: "MomentList",
    components: {UserAvatar, LikeComponent, Icon},
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        showLoginPopup: false,
      }
    },
    methods: {
      onShowMoment(item) {
        this.$router.push('/moment/' + item.id);
      },

      momentDescriptions(item) {
        if (item.description) {
          return item.description
        } else {
          return ""
        }
      },

      createdAt(item) {
        return createdAtDesc(item.created_at)
      },

      imgCountDesc(item) {
        if (item && item.image_count && item.image_count > 1) {
          return '' + item.image_count + 'P'
        } else {
          return ''
        }
      },

      onClickDigg(item) {
        if (!item.is_digg) {
          item.is_digg = true
          if(item.digg_count) {
            item.digg_count += 1
          } else {
            item.digg_count = 1
          }
        }
        this.$store.dispatch("DoItemUserAction", {"item_id": item.id, "action": "digg"}).then((data) => {
          if (data.code === 0) {
          } else if (data.code === 20010) {
            this.showLoginPopup = true
          }
        }, () => {

        })
      },

      onToUserProfile(user) {
        this.$router.push("/profile/"+ user.id)
      },

      getNickName(item) {
        if (!item || !item.user) {
          return ""
        }
        return item.user.nickname
      },

      coverUrl(item) {
        if (item && item.cover_url) {
          return item.cover_url
        } else {
          return ""
        }
      },

      diggText(item) {
        if (item && item.digg_count) {
          return item.digg_count
        } else {
          return "赞"
        }
      },
      commentText(item) {
        if (item && item.comment_count) {
          return item.comment_count
        } else {
          return "评论"
        }
      }
    },
    computed: {}
  };
</script>

<style lang="scss" scoped>

  .moment-list-container {
    background: white;
  }

  .moment-item-container {
    padding-bottom: 12px;
    border-bottom: 2px solid #e8e8e8;

    .title-container {
      padding: 14px 0;
      .user-info-container {
        display: flex;
        align-items: center;
        margin-left: 10px;

        .base-info-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 4px;

          .nickname {
            font-size: 14px;
            font-weight: bold;
            color: rgba(21, 21, 21, 0.87);
          }

          .post-time {
            margin-top: 6px;
            font-size: 12px;
            color: grey;
          }

        }
      }
    }

    .moment-info-box {
      font-size: 13px;

      .title-info {
        font-size: 14px;
        margin: 10px 12px;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* number of lines to show */

        .title-info-span {
          margin-right: 5px;
        }
      }

      .description-info {
        font-size: 14px;
        color: grey;
      }

      .images-container {
        position: relative;
        width: 100%;
        max-height: 800px;
        overflow: hidden;

        .img-count-container {
          position: absolute;
          right: 10px;
          bottom: 15px;

          .img-count {
            color: white;
            background: rgba(0, 0, 0, 0.35);
            font-size: 12px;
            padding: 2px 6px;
            -webkit-border-radius: 3px;
            -moz-border-radius: 3px;
            border-radius: 3px;
          }
        }

        .cover-container {
          position: relative;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .cover-img {
            max-width: 100%;
            /*position: absolute;*/
            /*top: 50%;*/
            /*left: 50%;*/
            /*display: block;*/
            /*<!--transform: translate(-50%, -50%);-->*/
          }
        }

      }
    }

    .item-action-box {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin-top: 16px;
      justify-content: flex-end;
      color: #444444;

      .action-item-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 12px;

        .digg-icon-font-fill {
          color: rgba(255, 0, 0, 0.68);
        }

        .icon-text {
          font-size: 12px;
          margin-top: 3px;
        }
      }
    }
  }


</style>
